import { useCallback, useEffect, useRef } from 'react';
export function useSwipe({ onLeftSwipe, onRightSwipe, onUpSwipe, onDownSwipe, yThreshold = 50, xThreshold = 30, }) {
    const area = useRef(null);
    const xDown = useRef(null);
    const yDown = useRef(null);
    const handleTouchStart = useCallback(evt => {
        const [firstTouch] = evt.touches;
        xDown.current = firstTouch.clientX;
        yDown.current = firstTouch.clientY;
    }, []);
    const handleTouchMove = useCallback(evt => {
        if (xDown.current === null || yDown.current === null) {
            return;
        }
        const [firstTouch] = evt.touches;
        const xUp = firstTouch.clientX;
        const yUp = firstTouch.clientY;
        const xDiff = xDown.current - xUp;
        const yDiff = yDown.current - yUp;
        if (Math.abs(xDiff) > Math.abs(yDiff)) {
            if (xDiff > xThreshold) {
                if (onRightSwipe) {
                    onRightSwipe(evt);
                }
            }
            else if (xDiff < -xThreshold) {
                if (onLeftSwipe) {
                    onLeftSwipe(evt);
                }
            }
        }
        else {
            if (yDiff > yThreshold) {
                if (onUpSwipe) {
                    onUpSwipe(evt);
                }
            }
            else if (yDiff < -yThreshold) {
                if (onDownSwipe) {
                    onDownSwipe(evt);
                }
            }
        }
    }, [onLeftSwipe, onRightSwipe, onUpSwipe, onDownSwipe, yThreshold, xThreshold]);
    const handleTouchEnd = useCallback(() => {
        xDown.current = null;
        yDown.current = null;
    }, []);
    useEffect(() => {
        if (!area.current) {
            return;
        }
        const node = area.current;
        node.addEventListener('touchstart', handleTouchStart, false);
        node.addEventListener('touchmove', handleTouchMove, false);
        node.addEventListener('touchend', handleTouchEnd, false);
        return () => {
            node.removeEventListener('touchstart', handleTouchStart);
            node.removeEventListener('touchmove', handleTouchMove);
            node.removeEventListener('touchend', handleTouchEnd);
        };
    }, [handleTouchStart, handleTouchMove, handleTouchEnd]);
    return { area };
}
//# sourceMappingURL=swipe.js.map